import React, { Component } from 'react';

import IconArrowRight from '../../assets/icons/IconArrowRight';

class NextPageButton extends Component {
    render() {
        return (
            <button type="button" id="btnnextpage" className="flex justify-center items-center h-8 w-8 rounded bg-white text-gray-400 outline-none focus:outline-none">
                <IconArrowRight />
            </button>
        );
    }
}

export default NextPageButton;